import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Coordinates, GeoLocationObject } from 'src/app/classes/geo-location-object';
import { Profile } from 'src/app/classes/profile';
import { ProfileUpdate } from 'src/app/classes/profile-update';
import { Van } from 'src/app/classes/van';
import { PROFILE_KEY } from 'src/app/common/constants';
import { CoordinatesService } from 'src/app/services/coordinates.service';
import { EventsDeltaService } from 'src/app/services/events-delta.service';
import { GeoLocationService } from 'src/app/services/geo-location.service';
import { LoggerService } from 'src/app/services/logger.service';
import { ProfileService } from 'src/app/services/profile.service';
import { ToastService } from 'src/app/services/toast.service';


export interface DialogData {
  type: string;
  vanInUseBy: string;
  lastVanUsed: string;
  vanList: Array<Van>;
}

@Component({
  standalone: false,
  selector: 'app-driver-welcome-modal',
  templateUrl: './driver-welcome-modal.component.html',
  styleUrls: ['./driver-welcome-modal.component.scss']
})
export class DriverWelcomeModalComponent implements OnInit {
type: string;
continueDisabled = true;
selectedVan;
processing = false;
location: GeoLocationObject = new GeoLocationObject();

  constructor(
    public dialogRef: MatDialogRef<DriverWelcomeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private geoLocationService: GeoLocationService,
    private logger: LoggerService,
    private toastService: ToastService,
    private eventsDeltaService: EventsDeltaService,
    private profileService: ProfileService,
    private coordinatesService: CoordinatesService,
  ) { }

  ngOnInit(): void {
    this.selectedVan = this.data.type === 'duplicateVan' ? null : this.data.lastVanUsed
  }

  loadProfile(): ProfileUpdate{
    const localStorageString = localStorage.getItem(PROFILE_KEY);
    return localStorageString !== null ? JSON.parse(localStorageString) : new ProfileUpdate();
  }

  saveProfileToLocalStorage(profileUpdate: ProfileUpdate){
    localStorage.setItem(PROFILE_KEY, JSON.stringify(profileUpdate));
  }

  subscribeToCoordinates(): void{
    this.coordinatesService.coordinates$.subscribe((coordinates: Coordinates) => {
      if (coordinates && coordinates.latitude && coordinates.longitude) {
        this.location.latitude = coordinates.latitude;
        this.location.longitude = coordinates.longitude;
      }
    });
  }

  saveProfile(){
      this.processing = true;
      const profile = this.profileService.profileObs$.getValue();
      let profileUpdate: ProfileUpdate = this.loadProfile();
      profileUpdate.latitude = this.location.latitude.toString();
      profileUpdate.longitude = this.location.longitude.toString();
      profileUpdate.driverName = this.makeAccountName(profile);
      profileUpdate.gemsid = profile.adId;
      profileUpdate.breakTime = '';
      profileUpdate.vanDriverVanNumberPref = this.selectedVan;
      this.logger.debug(`profileUpdate:`, profileUpdate, 'ui');
      this.profileService.saveProfile(profileUpdate)
      .subscribe(resp => {
        this.logger.debug(`PUT Asset response: ${resp.status} ${resp.statusText}`, resp, 'http');
        if(resp.status === 201){
          this.toastService.show('Profile Saved Successfully!', { classname: 'bg-success text-light', delay: 4000 });
          this.logger.debug('saving profile update to local storage', 'ui');
          this.saveProfileToLocalStorage(profileUpdate);
          setTimeout(() => {
            this.eventsDeltaService.getDeltas();
            this.dialogRef.close();
          }, 50);
        }else{
          this.toastService.show('Error Saving Profile!', { classname: 'bg-danger text-light', delay: 4000 });
        }
        this.processing = false;
      });
  }

  makeAccountName(profile: Profile): string {
    return `${profile.firstName[0].toUpperCase() || ''}. ${profile.lastName || ''}`;
  }

}
